module.exports = __webpack_public_path__ + "assets/images/bb5e61c195d7a468e9c3980b7eaa12a3.png";